import store from './libs/store'
import societyApi from './libs/api'
import societyHttp from './libs/http'
import societyDict from './libs/dict'
import societyUtil from './libs/util'

import mixinPages from './mixin/pages'

export { store, societyApi, societyHttp, societyDict, societyUtil, mixinPages }
